import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  error: "",
  message: "",
};

export const makeOfferActiveAction = createAsyncThunk(
  "make-offer-active",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.put(`/admins/api/make-offer-active`, { ...data });
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const makeOfferActiveSlice = createSlice({
  name: "make-offer-active",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(makeOfferActiveAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(makeOfferActiveAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(makeOfferActiveAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const makeOfferActiveReducer = makeOfferActiveSlice.reducer;
